<app-material [material]="false">
    <div class="header" header>
        <app-display-label
            label="{{'service.tickets.details.display.id' | translate}}:"
            [value]="ticket.id">
        </app-display-label>
        <app-display-label
            label="{{'service.tickets.details.display.description' | translate}}:"
            [value]="ticket.description">
        </app-display-label>
        <div *ngIf="ticket.ticketReport" class="ticket-report-row">
            <app-tooltip *ngIf="ticket.ticketReport.ticketReportPriority"
                [type]="getPriorityTooltipType()"
                [record]="getPriorityLabel()"
                tooltipPosition="top">
            </app-tooltip>
            <app-display-label
                label="{{ 'service.tickets.details.display.ticketToolReport' | translate }}:"
                [value]="getReportDisplayValue(ticket.ticketReport)"
                [hasHyperlinkValue]="!!ticket.ticketReport?.name"
                [valuePrefix]="getReportStatusPrefix(ticket.ticketReport)"
                [valuePrefixBold]="true"
                [valueLink]="ticket.ticketReport?.name"
                (onHyperlinkClick)="download(ticket.ticketReport)">
            </app-display-label>
        </div>
        <app-display-label *ngIf="!computeIsAutomatic"
                           label="{{'service.tickets.details.display.description' | translate}}:"
                           [value]="ticket?.description">
        </app-display-label>
        <app-display-label *ngIf="ticket.infoFromLine"
                           label="{{'service.tickets.details.display.lineInfo' | translate}}:"
                           [value]="ticket?.infoFromLine">
        </app-display-label>
        <app-display-label
            label="{{'service.tickets.details.display.createdBy' | translate}}:"
            [value]="ticket.createdByName">
        </app-display-label>
    </div>
    <div class="content" body>
        <div *ngIf="loading" class="loader">
            <app-loading-spinner></app-loading-spinner>

        </div>
        <div class="service-container">
            <div class="details" *ngIf="!loading">
                <app-tool-scan-tree
                    *ngIf="!needToScanTools() && activeTicketTools.length > 0"
                    [labelText]="'service.tickets.details.tools.label' | translate"
                    [emptyMessage]="'service.tickets.details.tools.emptyText' | translate"
                    [parameters]="[{'leafActionIcon':'select_all', 'value': 'positionLabel', 'label':'generic.currentPosition'},
                                   {'value': 'registeredTime', 'label':'admin.tickets.details-modal.panel.parameters.registeredTime' },
                                   {'value': 'registeredCycles', 'label':'admin.tickets.details-modal.panel.parameters.registeredCycles'},
                                   {'value': 'toolReturnId', 'label':'admin.tickets.details-modal.panel.parameters.toolReturnId'}]"
                    [loading]="loading"
                    [items]="activeTicketTools"
                    (leafIconClick)="onLeafIconClick($event)">
                </app-tool-scan-tree>
                <app-tool-scan-tree
                    *ngIf="!needToScanTools() && returnedTicketTools.length > 0"
                    [labelText]="'service.tickets.details.tools.return-label' | translate"
                    [emptyMessage]="'service.tickets.details.tools.emptyText' | translate"
                    [parameters]="[{'value': 'positionLabel', 'label':'generic.currentPosition'},
                                   {'value': 'registeredTime', 'label':'admin.tickets.details-modal.panel.parameters.registeredTime' },
                                   {'value': 'registeredCycles', 'label':'admin.tickets.details-modal.panel.parameters.registeredCycles'},
                                   {'value': 'toolReturnId', 'label':'admin.tickets.details-modal.panel.parameters.toolReturnId'}]"
                    [loading]="loading"
                    [items]="returnedTicketTools">
                </app-tool-scan-tree>
                <app-tool-inspect-tree
                    [isMaterial]="false"
                    *ngIf="needToScanTools()"
                    [isScanListenerActive]="true"
                    [labelText]="'service.tickets.details.tools.label' | translate"
                    [emptyMessage]="'service.tickets.details.tools.emptyText' | translate"
                    [formControl]="inspectForm.controls['scannedTools']"
                    [showErrors]="false"
                    [items]="ticket.ticketTools"
                    (itemNotFound)="onItemNotFound($event)"
                    (toolSelect)="onToolScanned($event)"
                    (toolsSelected)="onToolsScanned($event)">
                </app-tool-inspect-tree>
            </div>
            <div class="activities" *ngIf="!loading">
                <app-ticket-status [ticket]="ticket"
                                   (downloadFile)="download($event)"
                                   *ngIf="ticket">
                </app-ticket-status>
                <div class="controls">
                    <app-icon *ngIf="canRenderOnHoldButton()"
                              type="warning"
                              class="pause-button"
                              variant="fa-pause"
                              library="fontawesome"
                              (click)="onHoldOperation()">
                    </app-icon>
                    <app-icon *ngIf="canRenderResumeButton()"
                              type="info"
                              variant="fa-play"
                              library="fontawesome"
                              class="resume-button"
                              (click)="resumeOperation()">
                    </app-icon>
                </div>
                <app-on-hold-card *ngFor="let ticketEvent of ticket.ticketEvents"
                                  [ticketEvent]="ticketEvent"></app-on-hold-card>
            </div>
        </div>
    </div>
    <div class="footer" footer *ngIf="!loading">
        <div class="multiple-buttons-states">
            <app-button *ngIf="canRenderStartOperationButton()"
                        type="primary"
                        class="action-button"
                        [disabled]="waitingForTools()"
                        (clicked)="onStartOperation()">{{ 'generic.buttons.startOperation'| translate }}
            </app-button>
            <app-button *ngIf="canRenderFinishOperationButton()"
                        type="primary"
                        class="action-button"
                        (clicked)="onFinishOperation()">{{
                    'generic.buttons.finishOperation'|
                        translate
                }}
            </app-button>
            <app-button *ngIf="canRenderToolReportButton()"
                        type="primary"
                        [disabled]="waitingForTools()"
                        (clicked)="onToolReportGeneration()">{{ 'generic.buttons.toolReport'| translate }}
            </app-button>
                <app-button *ngIf="canRenderApproveToolReportButton()"
                type="primary"
                class="action-button"
                (clicked)="onApproveToolReport()">
                {{ 'generic.buttons.approveToolReport' | translate }}
            </app-button>
            <app-button *ngIf="canRenderCloseButton(ticket)"
                        [disabled]="!ticket.canBeClosed"
                        type="danger"
                        (clicked)="confirmCloseTicket()">
                {{ 'generic.buttons.cancel' | translate }}
            </app-button>
        </div>
    </div>
</app-material>

<div class="page">

</div>
<app-confirmation-modal #confirmOperation
                        (scanEvent)="onConfirmAction($event)"
                        [title]="modalTitle"
                        [question]="modalQuestion"
                        [message]="modalMessage">
</app-confirmation-modal>

<app-confirmation-modal #confirmCreateTicket
                        (scanEvent)="createTicket($event)"
                        [title]="createTicketModalTitle"
                        [question]="createTicketModalQuestion"
                        [message]="createTicketModalMessage">
</app-confirmation-modal>

<app-confirmation-modal #confirmOnHoldTicket
                        (scanEvent)="onConfirmOnHoldOperation($event)"
                        [title]="onHoldTicketModalTitle"
                        [question]="onHoldTicketModalQuestion"
                        [message]="onHoldTicketModalMessage">
</app-confirmation-modal>

<app-confirmation-modal #confirmResumeTicket
                        (scanEvent)="onConfirmResumeOperation($event)"
                        [title]="resumeTicketModalTitle"
                        [question]="resumeTicketModalQuestion"
                        [message]="resumeTicketModalMessage">
</app-confirmation-modal>

<app-intervention-modal title="{{'intervention-modal.title' | translate}}"
                        (confirmEvent)="onConfirmOperationData($event)">
</app-intervention-modal>

<app-tool-ticket-report-modal (confirmEvent)="onConfirmToolReportData($event)">
</app-tool-ticket-report-modal>
<app-confirmation-modal #confirmToolReportGeneration
                        (scanEvent)="onConfirmToolReport($event)"
                        title="{{'service.tickets.details.confirmation-modal.generate-tool-report.popupTitle' | translate }}"
                        question="{{'service.tickets.details.confirmation-modal.generate-tool-report.popupQuestion' | translate }}"
                        message="{{'service.tickets.details.confirmation-modal.generate-tool-report.popupMessage' | translate }}">
</app-confirmation-modal>

<app-ticket-create-modal (create)="onCreateTicket($event)"
                         [config]="tableConfig"
                         [isLoading]="loading">
</app-ticket-create-modal>

<app-tool-ticket-approve-modal
  (confirmEvent)="onConfirmApproveToolReport($event)"
  (cancelEvent)="onCancelApproveToolReport()">
</app-tool-ticket-approve-modal>

<app-info-modal title="{{'service.tickets.details.info-modal.title' | translate}}"
                [infoMessage]="infoMessage"
                [actionMessage]="actionMessage"
                [detailsMessage]="detailsMessage"
                (cancelInfoModal)="onCancelInfoModal()">
</app-info-modal>
<app-pdf-viewer></app-pdf-viewer>
<app-tool-position-modal
    [tool]="selectedTool"
    [hasReset]="true"
    [hasSpare]="!this.ticket.hasMaintenanceAtLine"
    [positions]="selectedToolPositions"
    (assign)="onAssignToolPosition($event)"
    (resetPosition)="onResetToolPosition($event)">
</app-tool-position-modal>

<app-ticket-on-hold-modal (confirmEvent)="onHoldOperationData($event)"></app-ticket-on-hold-modal>

<app-confirmation-modal #closeTicket
                        (scanEvent)="onCloseTicket($event)"
                        title="{{'atom.tickets.closeTicketPopup.popupTitle' | translate}}"
                        question="{{'atom.tickets.closeTicketPopup.popupQuestion' | translate}}"
                        message="{{'atom.tickets.closeTicketPopup.popupMessage' | translate}}"
                        [displayReasonMode]="false">
</app-confirmation-modal>
